import { useAuth } from "../../context/auth-context";
import type {
  PointsClaimRequestsEnvelope,
  PointsClaimRequestsPayload,
} from "./pointsClaimRequests";
import { apiQueryKey } from "./queryKeys";
import { useApiQuery } from "./useApiQuery";

const DEFAULT_LIMIT = 10;

export type UsePointsClaimRequestsParams = {
  page: number;
  limit?: number;
  enabled?: boolean;
};

export function usePointsClaimRequestsQuery(
  params: UsePointsClaimRequestsParams
) {
  const { isAuthenticated } = useAuth();
  const { page, limit = DEFAULT_LIMIT, enabled: enabledParam = true } = params;

  return useApiQuery<PointsClaimRequestsEnvelope, PointsClaimRequestsPayload>({
    queryKey: apiQueryKey("points-claim-requests", { page, limit }),
    url: "api/tasks/points-claim-requests",
    params: { page, limit },
    enabled: Boolean(isAuthenticated) && enabledParam,
    select: (body) => body.data,
  });
}
